const capitalize = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

const capitalizeAll = (str: string): string =>
  str.split(" ").map(capitalize).join(" ");

export { capitalize, capitalizeAll };
